import Alodokter from "../utils/Alodokter";

export default class VideoPlayerAnalytics {
  static vdProgress(data, item_category, vd_type, vd_percent) {
    Alodokter.sendEventGA4({
      item_id: data.id,
      item_name: data.title,
      item_category: item_category,
      item_category2: (data.is_paid || data.is_paid_webinar) ? "paid" : "free",
      registration_status: (data.user_status || data.is_registered) ? true : false,
      vd_type: vd_type,
      vd_percent: vd_percent,
      event: "vd_progress"
    })
  }
  static vdProgressLive(data, vd_duration) {
    Alodokter.sendEventGA4({
      item_id: data.id,
      item_name: data.title,
      item_category: "webinar",
      item_category2:  data.is_paid_webinar ? "paid" : "free",
      registration_status: data.is_registered ? true : false,
      vd_type: "webinar_live",
      vd_duration: vd_duration,
      event: "vd_progress"
    })
  }
  static vdStart(data, item_category, vd_type){
    Alodokter.sendEventGA4({
      item_id: data.id,
      item_name: data.title,
      item_category: item_category,
      item_category2: item_category != "skp" ? (data.is_paid || data.is_paid_webinar) ? "paid" : "free" : "",
      registration_status: item_category != "skp" ? (data.user_status || data.is_registered) ? true : false : "",
      vd_type: vd_type,
      event: "vd_start"
    });
  }
  
  static vdFinished(data, item_category, vd_type){
    Alodokter.sendEventGA4({
      item_id: data.id,
      item_name: data.title,
      item_category: item_category,
      item_category2: item_category != "skp" ? (data.is_paid || data.is_paid_webinar) ? "paid" : "free" : "",
      registration_status: item_category != "skp" ? (data.user_status || data.is_registered) ? true : false : "",
      vd_type: vd_type,
      event: "vd_finished"
    });
  }

  static vdQnaSubmit(data,msgInput) {
    const itemCategory2 = data.is_paid_webinar ? "paid" : "free";
    Alodokter.sendEventGA4({
        item_id: data.id,
        item_name: data.title,
        item_category: "webinar",
        item_category2: itemCategory2,
        registration_status: (data.is_registered) ? true : false,
        question:msgInput,
        event: "vd_qna_submit"
    });
  }
}